const isVisible = (
  $element: Element,
  $container: HTMLElement = document.body,
  threshold: number = 0.5,
) => {
  const { x: containerStart } = $container.getBoundingClientRect();
  const { x: elementStart, width: elementWidth } = $element.getBoundingClientRect();
  const visiblePixels = containerStart + elementStart + elementWidth;

  if (visiblePixels <= 0) {
    return false;
  }

  if (visiblePixels <= threshold) {
    return false;
  }

  return true;
};

export default isVisible;
